const CUSTOMER_TYPE = {
    PERSON: 'PERSON',
    COMPANY: 'COMPANY'
}

const CUSTOMER_STATUS = {
    BLOCKED: 'BLOCKED',
    NEW: 'NEW',
    VERIFIED: 'VERIFIED',
    VIP: 'VIP',
    INACTIVE: 'INACTIVE',
    ACTIVE: 'ACTIVE',
}

exports = module.exports = {
    CUSTOMER_TYPE,
    CUSTOMER_STATUS
}